module.exports = __webpack_public_path__ + "images/icons/ph_calendar_blank-0bd34aad92349390989e67036b5da99c.svg";